import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    username: '',
    groups: [],
    loggedIn: false,
    alertProps: {},
    alert: false
  },
  mutations: {
    setUser (state, payload) {
      state.username = payload.username
      state.groups = payload.groups
    },
    login (state) {
      state.loggedIn = true
    },
    logout (state) {
      state.loggedIn = false
    },
    showAlert (state, payload) {
      state.alertProps = payload
      state.alert = true
    },
    clearAlert (state) {
      state.alert = false
      state.alertProps = {}
    }
  },
  actions: {
  },
  plugins: [vuexLocal.plugin]
})
